import React from 'react';

const styles = {
  backgroundColor: '#f7e569',
  width: 'fit-content',
  borderRadius: '10px',
  lineHeight: '65%',
  height: '15px',
  marginLeft: '12px',
  marginTop: '3px',
  padding: '5px',
  fontSize: '11px',
  verticalAlign: 'center',
  display: 'flex',
  alignItems: 'center'
};

const UpdatedChip = () => <div style={styles}>UPDATED</div>;

export default UpdatedChip;
